export const SET_TREES_COUNT = (state, { count, effectiveness}) => {
   state.treesCount.count = count;
   state.treesCount.effectiveness = effectiveness;
}